import { FC } from 'react'
import { Col, Divider } from 'antd'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import { FullMeetingFragment, SelfreflectionQuestion } from '../../../types'
import { SelfreflectionEntry } from './SelfreflectionEntry'
import { TopicCard } from '../../../components/custom_components/TopicCard'
import { AvatarData } from '../appraisal-flow/shared/appraisal-types'

interface SelfreflectionTopicCardsEditProps {
  meeting: FullMeetingFragment
  questions: SelfreflectionQuestion[]
}

export const SelfReflectionTopicCardsEdit: FC<SelfreflectionTopicCardsEditProps> = ({ meeting, questions }) => {
  const renderQuestions = (index: number, question: SelfreflectionQuestion) => {
    const formikIndex = questions.indexOf(questions.find((q) => q.textId === question.textId)!)
    const { employee } = meeting
    return (
      <div key={index}>
        {index !== 0 && <Divider className="darker" />}
        <SelfreflectionEntry
          question={question}
          employeeId={employee.id}
          meetingId={meeting.id}
          avatarData={employee as AvatarData}
          formName={`form.${formikIndex}`}
        />
      </div>
    )
  }

  return (
    <PerFlexRow>
      <Col span={8}>
        <TopicCard icon="ownGrowth_stroke" heading="appraisalMeeting.stepSelfReflection.topicCard.heading.development">
          {questions
            .filter((question) => question.textId === 'srQuestion1' || question.textId === 'srQuestion2')
            .map((question, index) => renderQuestions(index, question))}
        </TopicCard>
      </Col>

      <Col span={8}>
        <TopicCard icon="project_stroke" heading="appraisalMeeting.stepSelfReflection.topicCard.heading.project">
          {questions.filter((question) => question.textId === 'srQuestion3').map((question, index) => renderQuestions(index, question))}
        </TopicCard>
      </Col>

      <Col span={8}>
        <TopicCard icon="skillsKnowledge_stroke" heading="appraisalMeeting.stepSelfReflection.topicCard.heading.skillsKnowledge">
          {questions
            .filter((question) => question.textId === 'srQuestion4' || question.textId === 'srQuestion5')
            .map((question, index) => renderQuestions(index, question))}
        </TopicCard>
      </Col>
    </PerFlexRow>
  )
}
